import toggleShowPublic from './toggleShowPublic';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
  toggleShowPublic
});

export default allReducers;
